/**
 * Tab component.
 */

import './_tabs.scss';
import { ApplicationConsumer } from '../../common/context';
import { Tabs } from 'antd';
import Home from '../home/home';
import Page from '../page/page';
import React from 'react';
import ResultEvaluate from '../result/result-evaluate';

const { TabPane } = Tabs;

const Tab = () => {
  return (
    <ApplicationConsumer>
      {context => (
        <Tabs
          activeKey={context.tab}
          onTabClick={tab => context.handleChangeTab(tab)}
          type={'card'}
        >
          <TabPane
            key={'1'}
            tab={context.getOption(context.isMatrix ? 'matrix.1.name' : 'evaluation.1.name')}
          >
            <Home changeToTab={context.handleChangeTab} />
          </TabPane>
          <TabPane
            key={'2'}
            tab={context.getOption(context.isMatrix ? 'matrix.2.name' : 'evaluation.2.name')}
          >
            <Page />
          </TabPane>
          <TabPane
            key={'3'}
            tab={context.getOption(context.isMatrix ? 'matrix.3.name' : 'evaluation.3.name')}
          >
            {context.isMatrix ? <Page /> : <ResultEvaluate />}
          </TabPane>
        </Tabs>
      )}
    </ApplicationConsumer>
  );
};

export default Tab;
